// extracted by mini-css-extract-plugin
export default {"modal":"ErrorsModal__modal___ckj6l","plainText":"ErrorsModal__plainText___ZB6G8","buttonWrapper":"ErrorsModal__buttonWrapper___pDtJD"};